module.exports = __webpack_public_path__ + "static/media/Details.c336be98.png";